<mat-card class="pageWrapper">
    <mat-card-content>
        <h2 mat-dialog-title>{{title}}</h2>
        <mat-card>
            <form [formGroup]="userForm">
                <div class="row padding-top">
                <div class="flex-container">
                    <div class="mat-field" >
                        <mat-label>Drive Id<span class="red">*</span></mat-label>
                        <mat-form-field class="full-width" appearance="outline">
                            <input name="driveId" matInput formControlName="driveId">
                        </mat-form-field>
                        <div *ngIf="userForm.get('driveId').invalid && 
                            userForm.get('driveId').errors && 
                                (userForm.get('driveId').dirty || userForm.get('driveId').touched)">
                            <small class="text-danger"
                                *ngIf="userForm.get('driveId').hasError('required')">
                                Drive Id is required.
                            </small>
                        </div>
                    </div>

                    <div class="mat-field" >
                        <mat-label>Drive Name</mat-label>
                        <mat-form-field class="full-width" appearance="outline">
                            <input name="driveName" matInput formControlName="driveName">
                        </mat-form-field>
                    </div>
                    <div class="mat-field">
                        <mat-label>User Email <span class="red">*</span></mat-label>
                        <mat-form-field class="full-width" appearance="outline">
                            <input name="userEmail" matInput formControlName="userEmail">
                        </mat-form-field>
                        <div *ngIf="userForm.get('userEmail').invalid && 
                            userForm.get('userEmail').errors && 
                                (userForm.get('userEmail').dirty || userForm.get('userEmail').touched)">
                            <small class="text-danger"
                                *ngIf="userForm.get('userEmail').hasError('required')">
                                User Email is required.
                            </small>
                            <small class="text-danger"
                                *ngIf="userForm.get('userEmail').hasError('email')">
                                Incorrect email format
                            </small>
                        </div>
                    </div>
                    
                </div>

                <div class="flex-container">
                    <div class="mat-field">
                        <mat-label>User Name </mat-label>
                        <mat-form-field class="full-width" appearance="outline">
                            <input name="userName" matInput formControlName="userName">
                        </mat-form-field>
                    </div>
                    <div class="mat-field">
                        <mat-label>Perm Type </mat-label>
                        <mat-form-field class="full-width" appearance="outline">    
                        <mat-select class="full-width" formControlName = "permType" >
                            <mat-option *ngFor="let perm of permType" [value]="perm.value">
                              {{perm.label}}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                        <!-- <mat-form-field class="full-width" appearance="outline">
                            <input name="permType" matInput formControlName="permType">
                        </mat-form-field> -->
                    </div>
                    
                    <div class="mat-field">
                        <mat-label>License Type<span class="red">*</span></mat-label>
                        <mat-form-field class="full-width" appearance="outline">    
                            <mat-select  formControlName = "licenseType" (selectionChange) = "selectRole($event)">
                                <mat-option *ngFor="let licenseType of licenseTypeOptions" [value]="licenseType.value">
                                {{licenseType.label}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div *ngIf="userForm.get('licenseType').invalid && 
                            userForm.get('licenseType').errors && 
                                (userForm.get('licenseType').dirty || userForm.get('licenseType').touched)">
                            <small class="text-danger"
                                *ngIf="userForm.get('licenseType').hasError('required')">
                                License Type is required.
                            </small>
                        </div>
                    </div>
                </div>

                <div class="flex-container">
                    <div class="mat-field">
                        <mat-label>Role <span class="red">*</span></mat-label>
                        <mat-form-field class="full-width" appearance="outline">    
                        <mat-select formControlName = "role" >
                            <mat-option *ngFor="let role of reqRoleOptions" [value]="role.value">
                              {{role.label}}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                        <div *ngIf="userForm.get('role').invalid && 
                            userForm.get('role').errors && 
                                (userForm.get('role').dirty || userForm.get('role').touched)">
                            <small class="text-danger"
                                *ngIf="userForm.get('role').hasError('required')">
                                Role is required.
                            </small>
                        </div>
                    </div>
                </div>
                       
                <div style="text-align: center;">
                    <button mat-raised-button (click)="submit()"  [disabled]="userForm.invalid" class="button-style" style="margin-right: 3%;">{{buttonText}}</button>
                    <button mat-raised-button (click)="cancel()"   class="button-style">Cancel</button>
                </div>
            </div>
        </form>
        </mat-card>
    </mat-card-content>
</mat-card>

